import type { RouteLocationRaw } from 'vue-router'

export function toTemplateRoutePath(template: { id: string, alias?: string | null }) {
  return { name: 'template-by-id', params: { id: [template.alias ?? template.id] } } satisfies RouteLocationRaw
}
